<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="500px"
    >
        <v-card>
            <v-container class="my-2">
                <v-card-title class="text-md-h6 text-center text-break mb-3 font-weight-bold">
                    {{ $t('indicators.messages.delete_indicators_question', {reportTitle: bible.title}) }}
                </v-card-title>

                <v-card-subtitle class="text-center">
                    {{ $t('indicators.messages.not_reversed_warning_message') }}
                </v-card-subtitle>

                <v-card-actions class="justify-center">
                    <v-btn
                        class="v-btn--red"
                        text
                        @click="confirmDelete"
                    >{{ $t('app.confirm') }}</v-btn>

                    <v-btn
                        class="v-btn--secondary"
                        text
                        @click="closeDialog"
                    >{{ $t('app.cancel') }}</v-btn>

                    <v-progress-circular
                        indeterminate
                        class="mt-2 ml-2"
                        v-if="deletingBible"
                        color="grey"
                        size="16"
                    ></v-progress-circular>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import {EventBus} from "@/event-bus";

export default {
    name: "DeleteBibleDialog",

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        bible: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            deletingBible: false,
        }
    },

    methods: {

        /**
         * Emits dialog confirmed event
         */
        confirmDelete() {
            this.deletingBible = false;

            this.$emit('confirmBibleDeletion')
        },

        /**
         * Closes the deletion dialog
         */
        closeDialog() {
            this.$emit('cancelBibleDeletion')
        },

        /**
         * Hides spinner after delete bible succeed
         */
        stopBibleDeletingSpinner() {
            this.deletingBible = false
        }
    },

    /*created() {
        EventBus.$on('reports.management.delete-report', this.stopBibleDeletingSpinner)
    }*/
}
</script>

<style scoped>

</style>
